import { Injectable } from '@angular/core';


import * as Sentry from '@sentry/browser';

import { FeatureFlagService } from '@app/modules/app-load/services/feature-flag.service';
import { environment } from '@env/environment';
import { AppConfigService } from '@app/modules/app-load/services/app-config.service';


@Injectable( {
  providedIn: 'root',
} )
export class RemoteLoggingService {
  private sentry: boolean;
  constructor(
    private appConfigService: AppConfigService,
    featureFlagService: FeatureFlagService
  ) {

    this.sentry = featureFlagService.featureOn( 'sentry' );
    console.log( '[sentry.enabled]', this.sentry );
  }

  initialize() {

    if ( this.sentry ) {
      console.log( 'initialized sentry' );
      Sentry.init( {
        dsn: this.appConfigService.getConfig().sentryEndpoint,
        release: `${environment.name}-${environment.version}`,
        environment:  this.appConfigService.getConfig().clientEnvironment
      } );
    }

  }
}
